import type { ExtractPropTypes, PropType } from 'vue';
import type Segmented from './segmented.vue';

export const SegmentedProps = {
  block: {
    type: Boolean,
    default: false,
  },
  segments: {
    type: Array as PropType<Record<string, any>[]>,
    default: () => [],
  },
  size: {
    type: String as PropType<'small' | 'default' | 'large' | ''>,
    default: '',
  },
  modelValue: {
    type: [String, Number],
    default: '',
  },
};

export type SegmentedPropsType = ExtractPropTypes<typeof SegmentedProps>;
export type SegmentedInstance = InstanceType<typeof Segmented>;
